import { Link } from "react-router-dom";
import { Clock, ChefHat } from "lucide-react";

export default function RecipeCard({ recipe, testIdPrefix = "recipe-card" }) {
  return (
    <Link
      to={`/recipes/${recipe.slug}`}
      data-testid={`${testIdPrefix}-${recipe.slug}`}
      className="jaf-card rounded-xl overflow-hidden flex flex-col"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[color:var(--jaf-surface)]">
        <img
          src={recipe.image_url}
          alt={recipe.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 ease-out hover:scale-[1.04]"
        />
        <span
          className="absolute top-3 left-3 inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-white/95 backdrop-blur"
          style={{ color: "var(--jaf-primary)" }}
          data-testid={`${testIdPrefix}-category-${recipe.slug}`}
        >
          {recipe.category}
        </span>
      </div>

      <div className="p-5 flex flex-col gap-3 flex-1">
        <h3 className="font-serif text-xl leading-snug">{recipe.title}</h3>
        <p
          className="text-sm leading-relaxed line-clamp-2"
          style={{ color: "var(--jaf-text-muted)" }}
        >
          {recipe.description}
        </p>

        <div className="mt-auto flex flex-wrap items-center gap-2 pt-2">
          <span
            className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full"
            style={{ backgroundColor: "var(--jaf-surface)", color: "var(--jaf-text)" }}
          >
            <Clock size={12} />
            {recipe.total_time_minutes} min
          </span>
          <span
            className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full"
            style={{
              backgroundColor: "rgba(124, 144, 130, 0.15)",
              color: "#506357",
            }}
          >
            <ChefHat size={12} />
            {recipe.difficulty}
          </span>
        </div>
      </div>
    </Link>
  );
}
